import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestTemplatesServiceUseGet = {
    path: "/templates/services/:identifier",
    method: RouteHttpVerb.GET,
    obfuscatePath: "full"
};
